import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const WalkInChip = () => {
  const { t } = useTranslation();
  return (
    <Chip
      size="small"
      color="secondary"
      label={t('calendar.walk_in_chip')}
      sx={{
        flexShrink: 0,
        fontWeight: 700,
        height: '20px',
        fontSize: '11px',
        bgcolor: 'secondary.light',
        color: 'secondary.dark',
      }}
    />
  );
};
